import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import VisibilityIcon from '@material-ui/icons/Visibility';

import ViewAsContainer from '../../containers/system/ViewAs';
import { post } from '../../modules/utility';

const styles = () => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	description: {
		color: '#666',
		marginBottom: 20,
		textAlign: 'left',
	},
	permissionChip: {
		margin: 2,
		height: 22,
		fontSize: 11,
	},
});

class ViewAs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			users: [],
			isLoading: true,
		};
	}

	componentDidMount() {
		post({
			method: 'user.search',
			params: {},
			callback: (errors, r) => {
				if (errors) {
					this.setState({ isLoading: false });
					return this.props.showErrors(_.isArray(errors) ? errors : [errors]);
				}
				const users = _.sortBy(_.get(r, ['collections', 'userCollection'], []), [
					'firstName',
					'lastName',
				]);
				this.setState({ users, isLoading: false });
			},
		});
	}

	handleViewAs = (userId) => {
		this.props.startViewAs({ userId });
		//- authUser rebuilds asynchronously; land them where every role has a home.
		this.props.push('/');
	};

	renderUserRow = (user) => {
		const { classes, authUser } = this.props;
		const { userId, firstName, lastName, email, role, permissions } = user;
		const isSelf = userId === authUser.userId;
		const permissionList = _.keys(permissions).sort();

		return (
			<TableRow key={userId}>
				<TableCell>
					{firstName} {lastName}
					{isSelf ? ' (you)' : ''}
				</TableCell>
				<TableCell>{email}</TableCell>
				<TableCell>{role}</TableCell>
				<TableCell>
					{permissionList.map((permission) => (
						<Chip key={permission} label={permission} className={classes.permissionChip} />
					))}
				</TableCell>
				<TableCell style={{ whiteSpace: 'nowrap' }}>
					{user.lastLoggedIn ? moment(user.lastLoggedIn).format('M/D/YY h:mma') : '-'}
				</TableCell>
				<TableCell align="right">
					<Button
						variant="outlined"
						size="small"
						color="primary"
						disabled={isSelf}
						startIcon={<VisibilityIcon />}
						onClick={() => this.handleViewAs(userId)}
					>
						View as
					</Button>
				</TableCell>
			</TableRow>
		);
	};

	render() {
		const { classes, authUser } = this.props;
		const { users, isLoading } = this.state;

		if (!authUser) {
			return null;
		}

		const canImpersonate = !!_.get(authUser, ['permissions', 'canImpersonateUsers']);

		return (
			<div style={{ width: '100%' }}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<Typography variant="h5" align="left" gutterBottom>
							View As
						</Typography>
						{!canImpersonate && (
							<Typography align="left">
								You do not have the canImpersonateUsers permission.
							</Typography>
						)}
						{canImpersonate && (
							<Paper className={classes.paper}>
								<div style={{ padding: 20 }}>
									<Typography className={classes.description}>
										Browse FMP as another user, with their role and permissions, to check what they
										can and cannot see. A warning banner stays on screen until you exit. Careful:
										anything you save while viewing is recorded as that user. The view expires on
										its own after 4 hours.
									</Typography>
									{isLoading && <Typography>Loading users…</Typography>}
									{!isLoading && (
										<Table size="small">
											<TableHead>
												<TableRow>
													<TableCell>Name</TableCell>
													<TableCell>Email</TableCell>
													<TableCell>Role</TableCell>
													<TableCell>Permissions</TableCell>
													<TableCell>Last Logged In</TableCell>
													<TableCell />
												</TableRow>
											</TableHead>
											<TableBody>{users.map(this.renderUserRow)}</TableBody>
										</Table>
									)}
								</div>
							</Paper>
						)}
					</Grid>
				</Grid>
			</div>
		);
	}
}

ViewAs.propTypes = {
	classes: PropTypes.object,
	authUser: PropTypes.object,
	startViewAs: PropTypes.func,
	showErrors: PropTypes.func,
	push: PropTypes.func,
};

export default ViewAsContainer(withStyles(styles)(ViewAs));
